<!--
  OPDS Facets Component
  Shows available facets for filtering catalog results
-->
<script lang="ts">
  import { opdsStore } from '../stores/opds.svelte';
  import type { OPDSFacet } from '@legere/opds-client';

  const { currentFeed } = $derived(opdsStore);

  async function selectFacet(facet: OPDSFacet) {
    try {
      await opdsStore.fetchFeed(facet.href, facet.title);
    } catch (err) {
      console.error('Failed to apply facet:', err);
    }
  }

  // Group facets by group name
  const facetGroups = $derived(() => {
    if (!currentFeed?.facets || currentFeed.facets.length === 0) {
      return new Map<string, OPDSFacet[]>();
    }

    const groups = new Map<string, OPDSFacet[]>();

    for (const facet of currentFeed.facets) {
      const groupName = facet.group || 'Filters';
      if (!groups.has(groupName)) {
        groups.set(groupName, []);
      }
      groups.get(groupName)!.push(facet);
    }

    return groups;
  });
</script>

{#if currentFeed?.facets && currentFeed.facets.length > 0}
  <div class="opds-facets bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4">
    <div class="facets-container">
      {#each [...facetGroups()] as [groupName, facets]}
        <div class="facet-group">
          <h3 class="facet-group-title text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            {groupName}
          </h3>

          <div class="facet-buttons flex flex-wrap gap-2">
            {#each facets as facet}
              <button
                on:click={() => selectFacet(facet)}
                class="facet-btn px-3 py-1.5 text-sm rounded-md transition-colors
                       {facet.active
                         ? 'bg-blue-600 dark:bg-blue-500 text-white'
                         : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
                       }"
                class:active={facet.active}
              >
                {facet.title}
                {#if facet.count !== undefined}
                  <span class="facet-count ml-1 text-xs opacity-75">
                    ({facet.count})
                  </span>
                {/if}
              </button>
            {/each}
          </div>
        </div>
      {/each}
    </div>
  </div>
{/if}

<style>
  .opds-facets {
    max-width: 100%;
    overflow-x: auto;
  }

  .facets-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .facet-group {
    display: flex;
    flex-direction: column;
  }

  .facet-btn {
    white-space: nowrap;
  }

  .facet-btn.active {
    font-weight: 500;
  }
</style>
